export class ListQueryExecutionsRequestFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "ListQueryExecutionsRequestFiltersId",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "ListQueryExecutionsRequestFiltersStatus",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "ListQueryExecutionsRequestFiltersCreatedAt",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListQueryExecutionsRequestFilters.attributeTypeMap;
    }
    constructor() {
    }
}
